import React from "react";
import Content from "./content";

// import Box from "../../assets/home/homeSphere.gif";
import BG from "../../assets/unique/uniqueBG.png";

function Unique() {
  return (
    <div
      className="h-screen w-full flex flex-col justify-start bg-gradient-to-b from-[#2B2E82] to-[#0A0918] bg-cover bg-center"
      style={{
        backgroundImage: `url(${BG})`,
        backgroundPositionY: "",
      }}
    >
      <Content />
    </div>
  );
}

export default Unique;
